"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = _interopRequireDefault(require("react"));
var _CatchFromControl = _interopRequireDefault(require("../CatchFromControl"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));
var _InputLabel = require("../InputLabel");
var _ListItemIcon = _interopRequireDefault(require("../ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("../ListItemText"));
var _DenyEdit = _interopRequireDefault(require("./components/DenyEdit"));
var _SelectDropdown = require("../SelectDropdown");
var _Stack = _interopRequireDefault(require("../Stack"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _VariantInput = _interopRequireDefault(require("../VariantInput"));
var _HintTooltip = _interopRequireDefault(require("./components/HintTooltip"));
var _Option = _interopRequireDefault(require("./components/Option"));
var _SelectInput = _interopRequireDefault(require("./components/SelectInput"));
var _constants = require("./constants");
var _useFilterOptions = require("./hooks/useFilterOptions");
var _useSelectedOptions = require("./hooks/useSelectedOptions");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["autoComplete", "autoFocus", "firstSelected", "autoWidth", "classes", "className", "color", "disabled", "error", "FormHelperTextProps", "SelectDisplayProps", "PopoverProps", "MenuProps", "fullWidth", "helperText", "helper", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "name", "onBlur", "onChange", "onFocus", "placeholder", "displayPlaceholder", "isDenyEdit", "required", "minRows", "maxRows", "value", "variant", "canDeselect", "width", "dropdownWidth", "dropdownAlign", "borderStyle", "scrollStrategy", "dense", "withAll", "withFilter", "withSelectAll", "multiple", "loading", "fetching", "options", "searchOptions", "renderOption", "renderGroup", "getOptionLabel", "getOptionValue", "getOptionInfo", "getOptionIconInfo", "groupBy", "readOnly", "renderValue", "tabIndex", "data-cy", "labelId", "MenuComponent", "MenuListComponent", "displayEmpty", "onOpen", "onClose", "markSelectedOption", "hideSelectedOption", "showCheckbox", "withDeselectButton", "displayTooltip", "onAdd", "addOptionLabel", "isOptionDisabled", "searchExp", "multipleSearch", "favorits", "favoritsLabel", "minOptionCountForSearch", "actions", "onSearch", "postFiltering", "previewItemsCount", "dropdownInputPlaceholder", "suffix"],
  _excluded2 = ["shortName"],
  _excluded3 = ["shortName"],
  _excluded4 = ["onChange", "onBlur", "onFocus"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'Select';
var CustomSelect = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var autoComplete = props.autoComplete,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    _props$firstSelected = props.firstSelected,
    firstSelected = _props$firstSelected === void 0 ? false : _props$firstSelected,
    autoWidth = props.autoWidth,
    classes = props.classes,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$error = props.error,
    error = _props$error === void 0 ? '' : _props$error,
    FormHelperTextProps = props.FormHelperTextProps,
    _props$SelectDisplayP = props.SelectDisplayProps,
    SelectDisplayProps = _props$SelectDisplayP === void 0 ? _constants.DEFAULT_SELECT_DISPLAY_PROPS : _props$SelectDisplayP,
    PopoverProps = props.PopoverProps,
    MenuProps = props.MenuProps,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth,
    helperTextProp = props.helperText,
    helper = props.helper,
    hiddenLabel = props.hiddenLabel,
    id = props.id,
    InputLabelProps = props.InputLabelProps,
    inputProps = props.inputProps,
    InputProps = props.InputProps,
    inputRef = props.inputRef,
    label = props.label,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$displayPlaceho = props.displayPlaceholder,
    displayPlaceholder = _props$displayPlaceho === void 0 ? false : _props$displayPlaceho,
    _props$isDenyEdit = props.isDenyEdit,
    isDenyEdit = _props$isDenyEdit === void 0 ? false : _props$isDenyEdit,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    minRows = props.minRows,
    maxRows = props.maxRows,
    valueProp = props.value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'outlined' : _props$variant,
    _props$canDeselect = props.canDeselect,
    canDeselect = _props$canDeselect === void 0 ? false : _props$canDeselect,
    width = props.width,
    dropdownWidthProps = props.dropdownWidth,
    _props$dropdownAlign = props.dropdownAlign,
    dropdownAlign = _props$dropdownAlign === void 0 ? 'left' : _props$dropdownAlign,
    borderStyle = props.borderStyle,
    scrollStrategy = props.scrollStrategy,
    dense = props.dense,
    withAllProp = props.withAll,
    _props$withFilter = props.withFilter,
    withFilter = _props$withFilter === void 0 ? true : _props$withFilter,
    withSelectAll = props.withSelectAll,
    multiple = props.multiple,
    loading = props.loading,
    fetching = props.fetching,
    options = props.options,
    searchOptions = props.searchOptions,
    renderOptionProp = props.renderOption,
    renderGroupProp = props.renderGroup,
    _props$getOptionLabel = props.getOptionLabel,
    getOptionLabel = _props$getOptionLabel === void 0 ? _SelectDropdown.defaultGetOptionLabel : _props$getOptionLabel,
    _props$getOptionValue = props.getOptionValue,
    getOptionValueProps = _props$getOptionValue === void 0 ? _SelectDropdown.defaultGetOptionValue : _props$getOptionValue,
    _props$getOptionInfo = props.getOptionInfo,
    getOptionInfo = _props$getOptionInfo === void 0 ? _constants.defaultGetOptionInfo : _props$getOptionInfo,
    _props$getOptionIconI = props.getOptionIconInfo,
    getOptionIconInfo = _props$getOptionIconI === void 0 ? _constants.defaultGetOptionIconInfo : _props$getOptionIconI,
    _props$groupBy = props.groupBy,
    groupBy = _props$groupBy === void 0 ? 'group' : _props$groupBy,
    readOnly = props.readOnly,
    renderValueProp = props.renderValue,
    tabIndex = props.tabIndex,
    dataCyProp = props['data-cy'],
    labelId = props.labelId,
    MenuComponent = props.MenuComponent,
    MenuListComponent = props.MenuListComponent,
    displayEmpty = props.displayEmpty,
    onOpen = props.onOpen,
    onClose = props.onClose,
    _props$markSelectedOp = props.markSelectedOption,
    markSelectedOption = _props$markSelectedOp === void 0 ? true : _props$markSelectedOp,
    _props$hideSelectedOp = props.hideSelectedOption,
    hideSelectedOption = _props$hideSelectedOp === void 0 ? false : _props$hideSelectedOp,
    _props$showCheckbox = props.showCheckbox,
    showCheckbox = _props$showCheckbox === void 0 ? false : _props$showCheckbox,
    _props$withDeselectBu = props.withDeselectButton,
    withDeselectButton = _props$withDeselectBu === void 0 ? false : _props$withDeselectBu,
    _props$displayTooltip = props.displayTooltip,
    displayTooltip = _props$displayTooltip === void 0 ? false : _props$displayTooltip,
    onAdd = props.onAdd,
    addOptionLabel = props.addOptionLabel,
    isOptionDisabled = props.isOptionDisabled,
    _props$searchExp = props.searchExp,
    searchExp = _props$searchExp === void 0 ? false : _props$searchExp,
    _props$multipleSearch = props.multipleSearch,
    multipleSearch = _props$multipleSearch === void 0 ? false : _props$multipleSearch,
    favorits = props.favorits,
    favoritsLabel = props.favoritsLabel,
    minOptionCountForSearch = props.minOptionCountForSearch,
    actions = props.actions,
    onSearch = props.onSearch,
    _props$postFiltering = props.postFiltering,
    postFiltering = _props$postFiltering === void 0 ? true : _props$postFiltering,
    _props$previewItemsCo = props.previewItemsCount,
    previewItemsCount = _props$previewItemsCo === void 0 ? 3 : _props$previewItemsCo,
    dropdownInputPlaceholder = props.dropdownInputPlaceholder,
    suffix = props.suffix,
    other = _objectWithoutProperties(props, _excluded);
  var getOptionValue = _react["default"].useCallback(function (opt) {
    if (!opt) {
      return undefined;
    }
    return getOptionValueProps(opt);
  }, [getOptionValueProps]);
  var isServerSideMode = !!onSearch;
  var isServerSideSearchScreen = isServerSideMode && !!searchOptions;
  var isServerSideInitScreen = isServerSideMode && !searchOptions;
  var helperText = error || helper || helperTextProp;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var withAll = isServerSideMode ? false : withAllProp;
  var dropdownWidth = _react["default"].useMemo(function () {
    return dropdownWidthProps ? parseInt(dropdownWidthProps, 10) : undefined;
  }, [dropdownWidthProps]);
  var resolvedOptions = _react["default"].useMemo(function () {
    return options ? options : _constants.DEFAULT_OPTIONS;
  }, [options]);
  var value = _react["default"].useMemo(function () {
    return (0, _isNil["default"])(valueProp) ? multiple ? _constants.EMPTY_MULTIPLE_VALUE : _constants.EMPTY_VALUE : valueProp;
  }, [multiple, valueProp]);
  var hasEmptyOption = _react["default"].useMemo(function () {
    return resolvedOptions === null || resolvedOptions === void 0 ? void 0 : resolvedOptions.some(function (opt) {
      return ['', undefined, null].includes(getOptionValue(opt));
    });
  }, [resolvedOptions, getOptionValue]);
  var selectedOptions = (0, _useSelectedOptions.useSelectedOptions)({
    options: options,
    value: value,
    getOptionValue: getOptionValue,
    multiple: multiple,
    hasEmptyOption: hasEmptyOption
  });
  var handleChange = _react["default"].useCallback(function (selectedOptions) {
    var optionValues = selectedOptions.map(getOptionValue).filter(function (v) {
      return v !== undefined && v !== '';
    });
    var v = multiple ? optionValues : optionValues.slice(-1).pop();
    var e = {};
    if (withAll) {
      var allSelected = !v.length || resolvedOptions.length === v.length;
      var newValue = allSelected ? [] : v;
      var event = _objectSpread(_objectSpread({}, e), {}, {
        persist: function persist() {},
        target: _objectSpread(_objectSpread({}, e.target), {}, {
          name: name,
          value: newValue
        })
      });
      onChange(event, newValue);
    } else {
      onChange({
        persist: function persist() {},
        target: _objectSpread(_objectSpread({}, e.target), {}, {
          name: name,
          value: v
        })
      }, v, selectedOptions.slice(-1).pop());
    }
  }, [onChange, resolvedOptions, getOptionValue, multiple, withAll]);
  var renderTooltip = _react["default"].useCallback(function (selectedOptions) {
    return selectedOptions.map(function (_ref, i) {
      var shortName = _ref.shortName,
        option = _objectWithoutProperties(_ref, _excluded2);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          display: 'block'
        },
        children: getOptionLabel(option)
      }, i);
    });
  }, [getOptionLabel]);
  var renderValue = _react["default"].useCallback(function (selectedOptions) {
    var displayValue = '';
    var optionInfo = null;
    var optionIconInfo = null;
    if (renderValueProp) {
      displayValue = renderValueProp(selectedOptions);
    } else if (selectedOptions.length) {
      if (multiple) {
        displayValue = selectedOptions.length > previewItemsCount ? "".concat(selectedOptions.length, " selected") : selectedOptions.map(function (_ref2) {
          var shortName = _ref2.shortName,
            option = _objectWithoutProperties(_ref2, _excluded3);
          return shortName || getOptionLabel(option);
        }).join(', ');
      } else {
        var selectedOption = selectedOptions[selectedOptions.length - 1];
        optionInfo = getOptionInfo(selectedOption);
        optionIconInfo = getOptionIconInfo(selectedOption);
        displayValue = getOptionLabel(selectedOption);
      }
    } else if (withAll) {
      displayValue = 'All';
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      "data-cy-value": displayValue,
      direction: 'row',
      spacing: 0.5,
      alignItems: 'center',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        noWrap: true,
        disableTooltip: true,
        variant: 'inherit',
        children: displayValue
      }), optionInfo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_HintTooltip["default"], {
        info: optionInfo,
        children: optionIconInfo
      }) : null]
    });
  }, [renderValueProp, multiple, withAll, value, getOptionLabel]);
  var renderGroup = _react["default"].useCallback(function (group, _ref3) {
    var selected = _ref3.selected,
      indeterminate = _ref3.indeterminate;
    if (renderGroupProp) {
      return renderGroupProp(group);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
      children: [showCheckbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
        style: {
          minWidth: 28
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], {
          edge: 'start',
          checked: selected,
          indeterminate: indeterminate,
          tabIndex: -1,
          disableRipple: true,
          color: 'primary',
          "data-cy-role": 'multiSelectCheckbox'
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        id: group.groupKey,
        primary: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          title: group.groupKey,
          noWrap: true,
          disableTooltip: true,
          variant: 'body1',
          bold: true,
          children: group.groupKey
        })
      })]
    });
  }, [showCheckbox, renderGroupProp]);
  var renderOption = _react["default"].useCallback(function (option, _ref4) {
    var selected = _ref4.selected,
      initialSelected = _ref4.initialSelected,
      focused = _ref4.focused,
      index = _ref4.index;
    var content;
    var groupName = option[groupBy];
    var isGrouped = !!groupName;
    if (renderOptionProp) {
      content = renderOptionProp(option, {
        selected: selected,
        focused: focused,
        index: index
      });
    } else {
      var _label = getOptionLabel(option);
      var _value = getOptionValue(option);
      var stringLabel = typeof _label === 'string' ? _label : undefined;
      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        "data-cy": "select-option-".concat(multiple ? _label : _value),
        "data-cy-role": 'selectOption',
        "data-cy-index": index,
        "data-cy-label": stringLabel,
        primary: _label,
        primaryTypographyProps: _objectSpread(_objectSpread({
          title: stringLabel,
          noWrap: true
        }, selected ? {
          sx: {
            fontWeight: 'bold'
          }
        } : {}), {}, _defineProperty({}, 'data-cy-role', 'optionPrimaryText')),
        secondary: isGrouped && initialSelected ? groupName : null,
        secondaryTypographyProps: {
          variant: 'caption'
        }
      });
    }
    var optionInfo = getOptionInfo(option);
    var optionIconInfo = getOptionIconInfo(option);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Option["default"], {
      optionInfo: optionInfo,
      optionIconInfo: optionIconInfo,
      isGrouped: isGrouped && !initialSelected,
      showCheckbox: showCheckbox,
      selected: selected,
      children: content
    });
  }, [renderOptionProp, showCheckbox, groupBy, getOptionLabel, getOptionInfo, getOptionIconInfo]);
  var handleStringifyOptions = _react["default"].useCallback(function (option) {
    var group = (0, _SelectDropdown.defaultGetOptionGroup)(option, groupBy);
    return "".concat(getOptionLabel(option)).concat(group ? " ".concat(group) : '');
  }, [groupBy, _SelectDropdown.defaultGetOptionGroup, getOptionLabel]);
  var filter = (0, _useFilterOptions.useFilterOptions)({
    enabled: postFiltering,
    searchExp: searchExp,
    stringify: handleStringifyOptions,
    multiple: multipleSearch
  });
  var notched = displayPlaceholder || withAll ? true : undefined;
  var shrink = displayPlaceholder || withAll ? true : undefined;
  var handleOpen = _react["default"].useCallback(function (e) {
    var _e$currentTarget, _e$currentTarget$clic;
    onOpen === null || onOpen === void 0 || onOpen(e);
    (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget$clic = _e$currentTarget.click) === null || _e$currentTarget$clic === void 0 || _e$currentTarget$clic.call(_e$currentTarget);
  }, [onOpen]);
  var InputComponent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_VariantInput["default"], {
    label: label,
    borderStyle: borderStyle,
    variant: variant,
    notched: notched
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl["default"], _objectSpread(_objectSpread({
    className: className,
    disabled: disabled,
    error: !!error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    size: 'small',
    style: {
      width: width
    }
  }, other), {}, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.InputLabel, _objectSpread(_objectSpread({
      htmlFor: id,
      id: inputLabelId,
      shrink: shrink
    }, InputLabelProps), {}, {
      children: label
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CatchFromControl["default"], {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select["default"], {
        inputComponent: _SelectInput["default"],
        input: InputComponent,
        inputProps: _objectSpread({
          id: id,
          name: name,
          autoFocus: autoFocus,
          autoWidth: autoWidth,
          classes: classes,
          className: className,
          value: selectedOptions,
          options: resolvedOptions,
          multiple: multiple,
          hideSelectedOption: hideSelectedOption,
          firstSelected: firstSelected,
          withFilter: withFilter,
          dropdownWidth: dropdownWidth,
          dropdownAlign: dropdownAlign,
          renderTooltip: renderTooltip,
          renderValue: renderValue,
          renderOption: renderOption,
          renderGroup: renderGroup,
          groupBy: groupBy,
          filter: filter,
          placeholder: placeholder,
          displayPlaceholder: displayPlaceholder,
          disabled: disabled,
          loading: loading,
          fetching: fetching,
          onFocus: onFocus,
          onBlur: onBlur,
          onOpen: handleOpen,
          onClose: onClose,
          onChange: handleChange,
          SelectDisplayProps: SelectDisplayProps,
          PopoverProps: PopoverProps,
          MenuProps: MenuProps,
          readOnly: readOnly,
          withSelectAll: withSelectAll,
          displayTooltip: displayTooltip,
          chaneStrategy: multiple ? 'close' : 'select',
          progressColor: color,
          required: required,
          tabIndex: tabIndex,
          inputRef: inputRef,
          dataCy: dataCyProp || dataCy,
          markSelectedOption: markSelectedOption,
          canDeselect: canDeselect,
          withDeselectButton: withDeselectButton,
          hiddenInputValue: multiple && value ? value.join(',') : value,
          displayEmpty: displayEmpty || withAll,
          MenuComponent: MenuComponent,
          MenuListComponent: MenuListComponent,
          isOptionDisabled: isOptionDisabled,
          withLabel: !!label,
          searchExp: searchExp,
          onAdd: onAdd,
          onSearch: onSearch,
          addOptionLabel: addOptionLabel,
          favorits: favorits,
          favoritsLabel: favoritsLabel,
          showCheckbox: showCheckbox,
          actions: actions,
          minOptionCountForSearch: minOptionCountForSearch,
          searchOptions: searchOptions,
          isServerSideMode: isServerSideMode,
          isServerSideSearchScreen: isServerSideSearchScreen,
          isServerSideInitScreen: isServerSideInitScreen,
          dropdownInputPlaceholder: dropdownInputPlaceholder,
          label: label,
          getOptionValue: getOptionValue,
          suffix: isDenyEdit && selectedOptions.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DenyEdit["default"], {}) : suffix,
          dataCyLabel: label
        }, inputProps)
      })
    }), (helperText === null || helperText === void 0 ? void 0 : helperText.length) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], _objectSpread(_objectSpread({
      id: helperTextId
    }, FormHelperTextProps), {}, {
      children: helperText
    }))]
  }));
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function cutomSelectRenderer(_ref5, ref) {
  var onChange = _ref5.onChange,
    onBlur = _ref5.onBlur,
    onFocus = _ref5.onFocus,
    props = _objectWithoutProperties(_ref5, _excluded4);
  var onChangeMemoryRef = _react["default"].useRef(onChange);
  onChangeMemoryRef.current = onChange;
  var onChangeMemory = _react["default"].useCallback(function () {
    var _onChangeMemoryRef$cu;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    (_onChangeMemoryRef$cu = onChangeMemoryRef.current) === null || _onChangeMemoryRef$cu === void 0 || _onChangeMemoryRef$cu.call.apply(_onChangeMemoryRef$cu, [onChangeMemoryRef].concat(args));
  }, []);
  var onFocusMemoryRef = _react["default"].useRef(onFocus);
  onFocusMemoryRef.current = onFocus;
  var onFocusMemory = _react["default"].useCallback(function () {
    var _onFocusMemoryRef$cur;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    (_onFocusMemoryRef$cur = onFocusMemoryRef.current) === null || _onFocusMemoryRef$cur === void 0 || _onFocusMemoryRef$cur.call.apply(_onFocusMemoryRef$cur, [onFocusMemoryRef].concat(args));
  }, []);
  var onBlurMemoryRef = _react["default"].useRef(onBlur);
  onBlurMemoryRef.current = onBlur;
  var onBlurMemory = _react["default"].useCallback(function () {
    var _onBlurMemoryRef$curr;
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    (_onBlurMemoryRef$curr = onBlurMemoryRef.current) === null || _onBlurMemoryRef$curr === void 0 || _onBlurMemoryRef$curr.call.apply(_onBlurMemoryRef$curr, [onBlurMemoryRef].concat(args));
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomSelect, _objectSpread(_objectSpread({
    onChange: onChangeMemory,
    onBlur: onBlurMemory,
    onFocus: onFocusMemory
  }, props), {}, {
    ref: ref
  }));
});